import React, { useState } from "react";
import { getDataWithEndpoint, request } from "../../../functions/request";
import {
  formatDateHourToBR,
  updateData,
} from "../../../functions/functionsUtility";
import { Button, Input, Select } from "antd";
import { DescriptionsLayout } from "../../../layout";
import { FaSave } from "react-icons/fa";

const estados = [{ value: "SP", label: "São Paulo" }];

const cotacoesLabel = [
  { label: "Dianteiro/Boi", value: "ata_diaboi" },
  { label: "Dianteiro/Vaca", value: "ata_diavac" },
  { label: "Dianteiro s/ Osso - Boi", value: "ata_diaossoboi" },
  { label: "Dianteiro s/ Osso - Vaca", value: "ata_diaossovac" },
  { label: "Traseiro de Boi", value: "ata_traboi" },
  { label: "Traseiro de Vaca", value: "ata_travac" },
  { label: "Traseiro s/ Osso - Boi", value: "ata_traossoboi" },
  { label: "Traseiro s/ Osso - Vaca", value: "ata_traossovac" },
  { label: "Ponta de Agulha - Boi", value: "ata_agulha" },
  { label: "Ponta de Agulha - Vaca", value: "ata_casado" },
  { label: "Equivalente Físico", value: "ata_equifis" },
];

export default function InterboisMercadoAtacadista() {
  const [cotacoesData, setCotacoesData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const aux = Object.entries(cotacoesData).map(([key, value], index) => {
    if (key !== "ata_data" && key !== "ata_uf") {
      const cotLabel = cotacoesLabel.find((label) => label.value === key);
      return {
        label: cotLabel ? cotLabel.label : key,
        children: (
          <Input
            className="input-number"
            value={value}
            disabled={isLoading}
            onChange={(event) => {
              const inputValue = event.target.value;
              const formattedValue = inputValue;
              const newData = {
                ...cotacoesData,
                [key]: formattedValue,
              };
              setCotacoesData(newData);
            }}
          />
        ),
        span: 2,
      };
    }
  });

  const items = [
    {
      label: "Estado",
      children: (
        <Select
          showSearch
          style={{ width: "100%" }}
          optionFilterProp="children"
          placeholder="Selecione um estado"
          filterOption={(input, option) =>
            (option?.label ?? "").includes(input)
          }
          filterSort={(optionA, optionB) =>
            (optionA?.label ?? "")
              .toLowerCase()
              .localeCompare((optionB?.label ?? "").toLowerCase())
          }
          options={estados}
          loading={isLoading}
          onChange={(value) => {
            setIsLoading(true);
            setCotacoesData([]);
            getDataWithEndpoint(
              "boi_atacado",
              `getBoiAtacadobyuf?uf=${encodeURIComponent(value)}`,
              "updateBoiAtacado"
            )
              .then((res) => {
                setCotacoesData(res);
              })
              .finally(() => {
                setIsLoading(false);
              });
          }}
          allowClear={true}
        />
      ),
      span: 3,
    },
    {
      label: "Última Alteração",
      children: formatDateHourToBR(cotacoesData.ata_data),
      span: 3,
    },
  ];

  return (
    <>
      <DescriptionsLayout
        title={"Interbois - Mercado Atacadista"}
        items={[...items, ...aux.filter(Boolean)]}
        extra={
          <div style={{ padding: 10, display: "flex", gap: 10 }}>
            <Button
              type="primary"
              size="large"
              htmlType="submit"
              icon={<FaSave />}
              disabled={isLoading}
              onClick={async () => {
                updateData({
                  ...cotacoesData,
                  endpoint: "updateBoiAtacado",
                  path: "boi_atacado",
                });
              }}
            >
              Atualizar
            </Button>
          </div>
        }
      />
    </>
  );
}
